import * as Sentry from "@sentry/react";
import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react";

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <SentryErrorBoundary
    fallback={() => (
      <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center bg-gray-900 text-white">
        <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
        <p className="mb-4">We're sorry - something's gone wrong on our end.</p>
        <div className="flex flex-row gap-x-4">
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Back to Home
          </button>
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            onClick={() => window.location.reload()}
          >
            Refresh Page
          </button>
        </div>
      </div>
    )}
  >
    {children}
  </SentryErrorBoundary>
);
